import qs from "qs";
import axios from "axios";

function instance(config) {
  let instance = axios.create({
    timeout: 5000, //5秒未响应则请求超时
    /**更改响应头 */
    headers: {
      "Content-Type": "application/x-www-form-urlencoded"
    },

    /**在发送前处理data数据 */
    transformRequest: [
      data => {
        if (!data || typeof data === "string") {
          return data;
        }

        // 如果是Form表单就直接跳过JSON转换
        if (data instanceof FormData) {
          return data;
        }

        return qs.stringify(data, {
          arrayFormat: "brackets",
          strictNullHandling: false
        });
      }
    ],
    ...config
  });

  /**在请求或响应被 then 或 catch 处理前拦截它们。处理响应数据 */
  instance.interceptors.response.use(
    response => {
      if (response.status < 200 || response.status >= 300) {
        return Promise.reject(response.statusText);
      }
      // 服务器没有返回正确的JSON格式
      if (typeof response.data === "string" && !response.data) {
        return Promise.reject("服务器没有响应正确的数据, 请检查参数是否正确。");
      }
      return Promise.resolve(response.data);
    },
    error => {
      if (error && error.response) {
        return Promise.reject({
          status: error.response.status,
          statusText: error.response.statusText
        });
      } else {
        return Promise.reject({ status: 500, statusText: "服务器故障" });
      }
    }
  );

  return instance;
}

export default instance();
